import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

const firebaseConfig = {
  apiKey: 'AIzaSyBz5QicT7TfvM5SR3Yu1HoauSk_BKBKBzs',
  authDomain: 'controle-de-ponto-222d8.firebaseapp.com',
  databaseURL: 'https://controle-de-ponto-222d8.firebaseio.com',
  projectId: 'controle-de-ponto-222d8',
  storageBucket: 'controle-de-ponto-222d8.appspot.com',
  messagingSenderId: '1048668821186'
};

firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();
const database = firebase.database();

export { firebase, auth, database };
